module.exports = __webpack_public_path__ + "img/合作银行.ab7f7796.png";